const $$splitLoaderImporter = () => import('/app/apps/web/src/routes/_app/label/$id.tsx?tsr-split=loader');
import { lazyFn } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_app/label/$id")({
  loader: lazyFn($$splitLoaderImporter, 'loader')
});